import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {
  baseUrl = environment.baseUrl;
  showHeader!: Observable<boolean>;
  showHeaderBS!: BehaviorSubject<boolean>;
  headerDetails!: Observable<any>;
  headerDetailsBS!: BehaviorSubject<any>;

  notificationsLoaded!: Observable<boolean>;
  notificationsLoadedBS!: BehaviorSubject<boolean>;

  changeNotification!: Observable<boolean>;
  changeNotificationBS!: BehaviorSubject<boolean>;

  selectedNotification!:Observable<any>;
  selectedNotificationBS!:BehaviorSubject<any>;

  constructor(
    private http: HttpClient
  ) {
    this.showHeaderBS = <BehaviorSubject<boolean>>new BehaviorSubject(true);
    this.showHeader = this.showHeaderBS.asObservable();

    this.headerDetailsBS = <BehaviorSubject<any>>new BehaviorSubject({});
    this.headerDetails = this.headerDetailsBS.asObservable();

    this.notificationsLoadedBS = <BehaviorSubject<boolean>>new BehaviorSubject(false);
    this.notificationsLoaded = this.notificationsLoadedBS.asObservable();

    this.changeNotificationBS = <BehaviorSubject<boolean>>new BehaviorSubject(false);
    this.changeNotification = this.changeNotificationBS.asObservable();

    this.selectedNotificationBS = <BehaviorSubject<any>>new BehaviorSubject(undefined);
    this.selectedNotification = this.selectedNotificationBS.asObservable();
  }

  updateShowHeader(showHeader: boolean) {
    this.showHeaderBS.next(showHeader);
  }

  updateHeaderDetails(details: any) {
    this.headerDetailsBS.next(details);
  }

  getNotifications(body: any) {
    return this.http.post(this.baseUrl + 'Notification/GetNotifications', body);
  }

  getNotificationById(body: any) {
    return this.http.post(this.baseUrl + 'Notification/GetNotificationById', body);
  }

  updateNotificationLoaded(loaded: boolean) {
    this.notificationsLoadedBS.next(loaded);
  }

  updateNotification(update: boolean) {
    this.changeNotificationBS.next(update);
  }

  updateSelectedNotification(notification:any){
    this.selectedNotificationBS.next(notification)
  }
}
